import { TileInfo } from 'app/home/index.functions';
import { foldersAPI } from 'api/folder';
import toast from 'app/toast/index';
import { TFunction } from 'i18next';
import { ToastType } from 'app/toast/Toast';

export const addElementToFolder = async (folder_id: number, item: TileInfo, t: TFunction): Promise<false | any> => {
    let toastType: ToastType = 'success';
    let message = t('added_to_folder');
    let newItem = false;

    try {
        newItem = await foldersAPI.addElementToFolder(folder_id ?? 0, item.element_id ?? 0, item.segment_value_id ?? 0);
        if (typeof newItem == 'undefined') {
            toastType = 'info';
            message = t('exists_folder');
        }
    } catch (e: any) {
        toastType = 'error';
        message = e.message;
    }

    showToastMsg(toastType, message, t);
    return newItem;
};

export const addElementToFavorite = async (favorite_id: number, item: TileInfo, t: TFunction): Promise<false | any> => {
    let toastType: ToastType = 'success';
    let message = t('added_to_favorite');
    let newItem = false;
    try {
        newItem = await foldersAPI.addElementToFavorite(
            favorite_id ?? 0,
            item.element_id ?? 0,
            item.segment_value_id ?? 0,
        );
    } catch (e: any) {
        toastType = 'error';
        message = e.message;
    }
    showToastMsg(toastType, message, t);
    return newItem;
};

export const removeElementFromFolder = async (
    folder_id: number,
    item: TileInfo,
    t: TFunction,
): Promise<false | any> => {
    let toastType: ToastType = 'success';
    let message = t('removed_from_folder');
    let newItem = false;

    try {
        newItem = await foldersAPI.removeElementFromFolder(
            folder_id ?? 0,
            item.element_id ?? 0,
            item.segment_value_id ?? 0,
        );
    } catch (e: any) {
        toastType = 'error';
        message = e.message;
    }
    showToastMsg(toastType, message, t);
    return newItem;
};

function showToastMsg(toastType: ToastType, message: string = '', t: TFunction) {
    toast(toastType, t(toastType), message, { duration: 5000 });
}
